export default {
  getTheme (state) {
    return state.theme;
  },
  getHeaderColor (state) {
    return state.theme && state.theme.headerColor;
  },
  getPrimaryColor (state) {
    return state.theme && state.theme.primaryColor;
  },
  getSecondaryColor (state) {
    return state.theme && state.theme.secondaryColor;
  },
  getBackgroundColor (state) {
    return state.theme && state.theme.backgroundColor;
  },
  getBackgroundImage (state) {
    return state.theme &&
            state.theme.tiledBackgroundImage &&
            state.theme.tiledBackgroundImage.fields &&
            state.theme.tiledBackgroundImage.fields.file &&
            state.theme.tiledBackgroundImage.fields.file.url
  },
  getHeadingFont (state) {
    return state.theme && state.theme.headingFont;
  },
  getBodyCopyFont (state) {
    return state.theme && state.theme.bodyCopyFont;
  },
  getBodyCopyFontLeading (state) {
    const bodyCopyFont = state.theme && state.theme.bodyCopyFont && state.theme.bodyCopyFont.fields;
    return bodyCopyFont && bodyCopyFont.modifyLeading;
  },
  getBodyCopyFontInputLeading (state) {
    const bodyCopyFont = state.theme && state.theme.bodyCopyFont && state.theme.bodyCopyFont.fields;
    return bodyCopyFont && bodyCopyFont.modifyInputLeading;
  },
  getHeadingFontDetail (state) {
    const headingFont = state.theme && state.theme.headingFont;
    return {
      fontFamily: headingFont && headingFont.fields && headingFont.fields.fontFamily,
      fontWeight: headingFont && headingFont.fields && headingFont.fields.fontWeight,
      uppercase: headingFont && headingFont.fields && headingFont.fields.uppercase,
      modifyLeading: headingFont && headingFont.fields && headingFont.fields.modifyLeading
    }
  },
  getBodyCopyFontDetail (state) {
    return fontWeightLabel => {
      let fontWeight = null;
      const bodyCopyFont = state.theme && state.theme.bodyCopyFont && state.theme.bodyCopyFont.fields;

      switch (fontWeightLabel) {
        case 'light':
          fontWeight = bodyCopyFont && bodyCopyFont.lightFontWeight;
          break;
        case 'normal':
          fontWeight = bodyCopyFont && bodyCopyFont.normalFontWeight;
          break;
        case 'heavy':
          fontWeight = bodyCopyFont && bodyCopyFont.heavyFontWeight;
          break;
        default:
          return null;
      }

      return {
        fontFamily: bodyCopyFont && bodyCopyFont.fontFamily,
        fontWeight,
        uppercase: bodyCopyFont && bodyCopyFont.uppercase
      }
    }
  },
  getCookieBannerStatus (state) {
    return state.cookieBanner && state.cookieBanner.enabled;
  },
  getCookieBannerFields (state) {
    return state.cookieBanner;
  },
  showCookieBanner(state) {
    return state.showCookieConsent;
  },
};
